import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const ManageContractorsInGroupMutation = (input, callback) => {
  commitMutation(getEnvironment(), {
    mutation: graphql`
      mutation ManageContractorsInGroupMutation($input: ManageContractorsInGroupInput!) {
        manageContractorsInGroup(input: $input) {
          group {
            id
          }
        }
      }
    `,
    variables: {
      input
    },
    onCompleted: (response, errors) => {
      callback(response.manageContractorsInGroup, errors);
    },
    onError: err => console.error(err)
  });
};

export default ManageContractorsInGroupMutation;
